export class IdImporteMovimientoDto {

  public id? : number;
  public importe? : number;
  public importePunitorio? : number;
  public anulado?: boolean = false
  public idTipoMovimiento? : number;
}
